import React from 'react'
import styles from './CompanyList.module.css'
import { FaHome } from 'react-icons/fa';
import adlogo from '../Images/AdManagerLogo.png'
import { Link } from "react-router-dom";
import companyLogo from "../Images/CompanyLogo.png"

const CompanyList = () => {
    return (
        <>
            <div className={styles.home}>
                <div className={styles.side}>
                    <div>
                        <Link to="/home" className={styles.homeTitle}>
                            <FaHome size={22} className={styles.logo} />
                            <div className={styles.text}>Home</div>
                        </Link>
                        <Link to="/admanager" className={styles.manager}>
                            <div className={styles.admanag}><img src={adlogo} alt="" /></div>
                            <div className={styles.text}>Ads screening</div>
                        </Link>
                    </div>
                </div>
                <div className={styles.right}>
                    <div className={styles.inner}>
                        <div className={styles.card}>
                            <div className={styles.name}>
                                <img src={companyLogo} alt="" className={styles.comLogo} />
                                <div className={styles.companyName}>
                                    <div className={styles.comHeading}>Company name</div>
                                    <button className={styles.check}>Check ads</button>
                                </div>
                            </div>
                            <div className={styles.detail}>
                                <div className={styles.custName}>Name: Jack Mapster</div>
                                <div className={styles.custName}>Email” 1234@email.com</div>
                                <div className={styles.custName}>Company address: Lazy street 4, 7485 YT London, UK</div>
                                <div className={styles.custName}>VAT: 1234567</div>
                            </div>
                            <div className={styles.PauzeButtons}>
                                <div className={styles.pauze}>Pauze</div>
                                <div className={styles.delete}>Delete</div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default CompanyList
